export const POSITIONS = [
    'center',
    'top left',
    'top right',
    'bottom left',
    'bottom right',
];
export const isValidPosition = (position) => POSITIONS.includes(position);
